<template>
  <div
    v-if="label"
    class="input-field mb-0"
  >
    <label class="font-medium">
      {{ label }}
    </label>
  </div>

  <input
    ref="fileInput"
    type="file"
    class="hidden"
    :accept="accept"
    :multiple="multiple"
    @change="handleFileChange"
    @click.stop
  >

  <AppButton
    v-bind="$attrs"
    :disabled="disabled || processing"
    :processing="processing"
    :icon="icon"
    :text="text"
    :screen-reader-text="screenReaderText"
    @click="triggerBrowse"
  />
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import { AppButton } from '@/components/app';

defineOptions({ inheritAttrs: false });

const emit = defineEmits([
  'file-selected',
  'update:preview',
  'click',
]);

const props = defineProps({
  disabled: { type: Boolean, default: false },
  processing: { type: Boolean, default: false },
  screenReaderText: { type: String, default: '' },
  icon: { type: Object, default: () => null },
  text: { type: String, default: null },
  accept: { type: String, default: 'image/*' },
  multiple: { type: Boolean, default: false },
  preview: { type: String, default: null },
  label: { type: String, default: null },
});

const fileInput = ref(null);
let activeBlobUrl = null;

const triggerBrowse = (event) => {
  if (props.disabled || props.processing) return;
  emit('click', event);
  fileInput.value?.click();
};

const revokeBlob = () => {
  if (activeBlobUrl) {
    URL.revokeObjectURL(activeBlobUrl);
    activeBlobUrl = null;
  }
};

const handleFileChange = (event) => {
  const files = event.target.files;
  if (!files || !files.length) return;

  const file = files[0];
  emit('file-selected', props.multiple ? files : file);

  if (file.type.startsWith('image/')) {
    revokeBlob();
    activeBlobUrl = URL.createObjectURL(file);
    emit('update:preview', activeBlobUrl);
  }

  event.target.value = '';
};

watch(
  () => props.preview,
  (newVal) => {
    if (!newVal) {
      revokeBlob();
    }
  },
);

onBeforeUnmount(() => {
  revokeBlob();
});
</script>
